import { useEffect } from "react";

// Sends a question another page handed to the assistant, such as an insights
// card's "Ask GT a follow-up". sendMessage refuses while an answer is still
// streaming, so the question waits until the chat is free instead of being
// dropped.
const usePendingPrompt = ({ pendingPrompt, isAiThinking, clearPendingPrompt, sendMessage }) => {
  useEffect(() => {
    if (!pendingPrompt || isAiThinking) return;
    clearPendingPrompt();
    sendMessage(pendingPrompt);
  }, [pendingPrompt, isAiThinking, clearPendingPrompt, sendMessage]);
};

export default usePendingPrompt;
